module.exports = __webpack_public_path__ + "static/2-3131bebd284b13fccd2e361b86fe0f93.pdf";